import floorFigure from './floorFigure'

export default function updateBalance(balanceUpdateOn: "now" | "onVariable" | undefined,
    setlocalBalance: (x: string) => void,
    betInfoBalance: string,
    toFix: number,
    updateNow: boolean | undefined) {
    switch (balanceUpdateOn) {
        case 'now':
            return setlocalBalance(floorFigure(betInfoBalance, toFix))
        case 'onVariable':
            return updateNow && setlocalBalance(floorFigure(betInfoBalance, toFix))
        default:
            break
    }
}